import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5de86d20"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/img_chattop.png",
    alt: "AI智能客服",
    class: "object-contain mx-auto"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 right-0 text-center p-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-white whitespace-nowrap" }, " AI intelligent customer service ")
  ])
], -1))
const _hoisted_2 = {
  class: "dialog-content hidden-scrollbar flex-1 p-2",
  ref: "dialogContent"
}
const _hoisted_3 = { class: "flex items-start justify-start mb-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar-container mr-2" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/ico_head_robot.png",
    class: "dialog-icon w-10 h-10 rounded-full",
    alt: "Bot"
  })
], -1))
const _hoisted_5 = { class: "bot-message p-2 rounded-lg inline-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "avatar-container mr-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/ico_head_robot.png",
  class: "dialog-icon w-10 h-10 rounded-full",
  alt: "robot"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  class: "avatar-container ml-2"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/ico_head_visitor.png",
  class: "dialog-icon w-10 h-10 rounded-full",
  alt: "visitor"
}, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-8",
  src: "/img/ico_send.png"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "chat-dialog text-secondary bg-transparent fixed right-4 z-2001 rounded-lg overflow-visible flex flex-col" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "flex items-center justify-center bg-transparent text-white rounded-t-lg px-2 p-0" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "dialog-info q-dark" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (question.isTitle)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(question.text), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "link-text cursor-pointer pl-2",
                              onClick: _withModifiers(($event: any) => (_ctx.handleLinkClick(question.text)), ["prevent"])
                            }, " - " + _toDisplayString(question.text), 9, _hoisted_7)),
                        _hoisted_8
                      ], 64))
                    }), 128))
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: message.id,
                    class: _normalizeClass([
              'flex no-wrap items-start mb-2',
              message.user ? 'justify-end' : 'justify-start',
            ])
                  }, [
                    (!message.user)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'rounded-lg inline-block',
                message.user ? 'user-message' : 'bot-message',
              ])
                    }, [
                      (!message.user)
                        ? (_openBlock(), _createElementBlock("pre", {
                            key: 0,
                            innerHTML: message.text
                          }, null, 8, _hoisted_13))
                        : (_openBlock(), _createElementBlock("pre", _hoisted_14, _toDisplayString(message.text), 1)),
                      (_ctx.isSending && !message.user && message.text === '')
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 2,
                            name: "mdi-loading",
                            class: "animate-spin p-2"
                          }))
                        : _createCommentVNode("", true)
                    ], 2),
                    (message.user)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ], 512)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "dialog-footer q-dark flex items-center justify-between p-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, {
                modelValue: _ctx.userInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInput) = $event)),
                type: "textarea",
                autogrow: "",
                placeholder: "Please enter your question",
                onKeydown: _ctx.handleKeyDown,
                class: "input-textarea hidden-scrollbar flex-1 px-4 py-2 rounded mr-2"
              }, null, 8, ["modelValue", "onKeydown"]),
              _createVNode(_component_q_btn, {
                onClick: _ctx.sendMessage,
                disabled: _ctx.isSending,
                class: "send-button p-0 mr-2",
                flat: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.isSending)
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        name: "mdi-loading",
                        class: "animate-spin w-8"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}